export const SET_DOZENTEN_STATI = "setDozentenStati";
export const SET_ABRECHNUNGS_STATI = "setAbrechnungsStati";
export const SET_PLANUNGS_STATI = "setPlanungsStati";
export const SET_DURCHFUEHRUNGS_STATI = "setDurchfuehrungsStati";
export const SET_DOZENTENBUCHUNG_TYPEN = "setDozentenbuchungTypen";
